import React, { useContext, useEffect } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import './Home.css';

const Home = () => {
  const { language } = useContext(LanguageContext);

  const content = {
    ar: {
      welcome: 'مرحبًا بكم في منظمة الخلد للإعمار والتنمية',
      description: 'نحن منظمة خيرية تطوعية تعمل في مجالات الإعمار، التنمية البشرية، والعمل الإنساني.',
      goals: 'أهداف المنظمة',
      goalList: [
        'تحقيق معاني الرحمة وإشاعة روح التعاون والتكافل بين أفراد المجتمع.',
        'إغاثة الفقراء والمساكين وتأهيلهم وتنمية قدراتهم.',
        'العمل على محاربة التصحر ودرء آثار الجفاف والكوارث الطبيعية.',
        'رعاية المعاقين وذوي الاحتياجات الخاصة وتأهيلهم.',
        'نشر ثقافة السلام لتحقيق الاستقرار والتنمية المستدامة.',
      ],
      additionalTitle: 'خدماتنا الرئيسية',
      additionalContent: [
        'تقديم الدعم الإنساني للأيتام والمحتاجين.',
        'بناء وتأهيل المنازل للمتضررين من الكوارث.',
        'توفير المياه الصالحة للشرب عن طريق حفر الآبار.',
        'تنظيم حملات توعوية وصحية لتحسين جودة الحياة.',
        'دعم التعليم من خلال توفير المواد الدراسية.',
      ],
    },
    en: {
      welcome: 'Welcome to Alkhold Organization for Development',
      description: 'We are a charitable organization working in development and humanitarian aid.',
      goals: 'Our Goals',
      goalList: [
        'Promote compassion and cooperation among community members.',
        'Support and train the poor to improve their livelihood.',
        'Combat desertification and address natural disasters.',
        'Provide care and rehabilitation for people with special needs.',
        'Spread the culture of peace for sustainable development.',
      ],
      additionalTitle: 'Our Key Services',
      additionalContent: [
        'Providing humanitarian support to orphans and those in need.',
        'Building and rehabilitating homes for disaster victims.',
        'Ensuring access to clean drinking water by drilling wells.',
        'Organizing awareness and health campaigns to improve quality of life.',
        'Supporting education by providing school supplies.',
      ],
    },
  };

  const langContent = content[language];

  useEffect(() => {
    if (language === 'ar') {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }, [language]);

  return (
    <div className="home">
      <section className="intro">
        <h2>{langContent.welcome}</h2>
        <p>{langContent.description}</p>
      </section>

      <section className="goals">
        <h2>{langContent.goals}</h2>
        <ul>
          {langContent.goalList.map((goal, index) => (
            <li key={index}>{goal}</li>
          ))}
        </ul>
      </section>

      <section className="additional-content">
        <h2>{langContent.additionalTitle}</h2>
        <ul>
          {langContent.additionalContent.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default Home;
